import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { LatestNewsSectionComponent } from '../home/components/latest-news-section/latest-news-section.component';
import { LinksSectionComponent } from '@shared/components/links-section/links-section.component';
import { SideNavigationComponent } from '@shared/components/side-navigation/side-navigation.component';
import { IDetails_Response } from '@shared/constants/models.const';
import { BreadcrumbsComponent } from '@shared/components/breadcrumbs/breadcrumbs.component';
import { ThreeColumnTemplateComponent } from '@templates/three-column-template/three-column-template.component';
import { E_CONTENT_TYPE, E_FOLDER_TYPES } from '@shared/constants/enums.const';
import { CkViewerComponent } from '@shared/components/ck-viewer/ck-viewer.component';
import { ViewletComponent } from '@shared/components/viewlet/viewlet.component';
import { TranslateModule } from '@ngx-translate/core';
import { TocComponent } from '@shared/components/toc/toc.component';
import { BUTTON_TYPES } from '@shared/components/button/button-types.enum';
import { HorizontalDividerComponent } from '@shared/components/horizontal-divider/horizontal-divider.component';
import { HelperService } from '../../services/helper.service';
import { INavigation } from '@shared/components/side-navigation/side-navigation.model';
import { RelatedItemsComponent } from '@shared/components/related-items/related-items.component';
import { DefaultPortletsComponent } from '@shared/components/default-portlets/default-portlets.component';
import { CollectionsComponent } from '@shared/components/collections/collections.component';


@Component({
  selector: 'app-content-page',
  imports: [
    LatestNewsSectionComponent,
    LinksSectionComponent,
    SideNavigationComponent,
    BreadcrumbsComponent,
    ThreeColumnTemplateComponent,
    CkViewerComponent,
    ViewletComponent,
    TranslateModule,
    TocComponent,
    HorizontalDividerComponent,
    RelatedItemsComponent,
    DefaultPortletsComponent,
    CollectionsComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './content-page.component.html',
  styleUrl: './content-page.component.scss',
})
export class ContentPageComponent {
  showRootElem = input<boolean>(true);
  showTags = input<boolean>(true);
  pageData = input<IDetails_Response | any>();
  customNavigation = input<INavigation | any>([]);
  customDateField = input<string>('');

  protected readonly ButtonTypes = BUTTON_TYPES;
  isProjectFolder = computed(() => {
    return this.pageData()?.type === E_FOLDER_TYPES.Folder && this.pageData()?.folderType === E_FOLDER_TYPES.Project;
  });
  contentType = computed<E_FOLDER_TYPES>(() => {
    return this.HELPER.contentType;
  });
  protected readonly E_FOLDER_TYPES = E_FOLDER_TYPES;
  protected readonly E_CONTENT_TYPE = E_CONTENT_TYPE;

  private HELPER: HelperService = inject(HelperService);

}
